// apiClients.js
import axios from "axios";
import { getToken, handleSessionTimeout } from "../APIs/auth";

const createClient = (baseURL, envKey) => {
  const client = axios.create({
    baseURL,
    // timeout: 30000,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  // Request interceptor
  client.interceptors.request.use(async (config) => {
    const tokenData = await getToken();
    if (tokenData?.token) {
      config.headers.Authorization = `Bearer ${tokenData.token}`;
    }
    return config;
  });

  // Response interceptor
  client.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error.response?.status === 401) {
        handleSessionTimeout();
      }

      const message =
        error.response?.data?.Message ||
        error.response?.data?.Status ||
        error.message ||
        "Something went wrong";

      return Promise.reject(new Error(message));
    }
  );

  return client;
};

// ✅ Create clients with dynamic environment keys
export const coreApi = createClient(process.env.REACT_APP_CORE_API);
export const loginApi = createClient(process.env.REACT_APP_LOGIN_API);
export const payableApi = createClient(process.env.REACT_APP_PAYABLE_API);
export const uploadApi = createClient(process.env.REACT_APP_UPLOAD_API);
export const dailySaleApi = createClient(process.env.REACT_APP_OTB_API);
export const laborApi = createClient(process.env.REACT_APP_LABOR_API);
export const otbApi = dailySaleApi;